import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import {AuthenticationRoutes} from './login-routing.module';
import { AuthenticationComponent } from './components/authentication/authentication.component';
import { ClientSelectionComponent } from './components/client-selection/client-selection.component';
import {TranslateModule} from '@ngx-translate/core';
import { FirstLoginComponent } from '../login/components/first-login/first-login.component';
import { LayoutCustomModule } from '../../layouts/layout.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { ForgotpasswordComponent } from './components/Forgot-Password/forgot-password.component';
import { ResetpasswordComponent } from './components/Reset-Password/Reset-Password.component';
import { InvalidLinkComponent } from './components/invalid-link/invalid-link.component';
import { FirstLoginPasswordResetComponent } from './components/first-login-passwordreset/first-login-passwordreset.component';


@NgModule({
    declarations: [AuthenticationComponent, ClientSelectionComponent, FirstLoginComponent, ForgotpasswordComponent, ResetpasswordComponent, InvalidLinkComponent, FirstLoginPasswordResetComponent],
      
      imports: [
            CommonModule,
            MatExpansionModule,
            FormsModule,
            ReactiveFormsModule,
            TranslateModule,
            LayoutCustomModule,
            SharedModule,
            RouterModule.forChild(AuthenticationRoutes),
      ],
      exports:[AuthenticationComponent, ClientSelectionComponent, FirstLoginComponent,ForgotpasswordComponent,InvalidLinkComponent]
})
export class LoginModule { }
